module.exports = __webpack_public_path__ + "static/media/spinner.75ae2ba2.gif";